export default __webpack_public_path__ + "static/css/cms-ui.min.css";